<app-label-configuration
  [title]="'P0003601.installation.filtration.programmeTitre' | translate"
  [information]="openEnSavoirPlus"
  [titleListe]="'P0003601.installation.filtration.programme' | translate"
  [description]="
    'P0003601.installation.filtration.programmeDescription' | translate
  "
  [value]="actionStack!.getValue('fvsCProgrammeFiltrationAuto')"
  [liste]="P0003601ProgrammeFiltrationAuto"
  (onPress)="
    this.actionStack!.editValue(
      P00039DataRxTxIndex.FiltrationVS_Controle,
      'fvsCProgrammeFiltrationAuto',
      $event
    );
    this.actionStack!.commit()
  "
>
</app-label-configuration>

@if (actionStack!.getValue('fvsCProgrammeFiltrationAuto') === 1) {
  <app-two-choices-control
    [title]="'P0003601.programme.horlogeHiver' | translate"
    [firstLabel]="
      'P00039.lighting.functionality.parameters.setting.title.clock.day'
        | translate
    "
    [firstValue]="0"
    [secondLabel]="
      'P00039.lighting.functionality.parameters.setting.title.clock.week'
        | translate
    "
    [secondValue]="1"
    [value]="actionStack!.getValue('fvsPTypeHorlogePPH')"
    (onChange)="
      this.actionStack!.editValue(
        P00039DataRxTxIndex.FiltrationVS_Parametrage2,
        'fvsPTypeHorlogePPH',
        $event
      );
      this.actionStack!.commit()
    "
  >
  </app-two-choices-control>

  @if (this.actionStack!.getValue('fvsPTypeHorlogePPH') === 0) {
    <app-larged-link
      [name]="
        'P0003600.installation.filtration.programmePPH.horlogePicotsJoursPPH.programmeTitre'
          | translate
      "
      (onPress)="goToFunctionParametersSettingsClockScreen()"
    >
    </app-larged-link>
  } @else {
    <app-larged-link
      [name]="
        'P0003600.installation.filtration.programmePPH.horlogePicotsJoursPPH.programmeTitre'
          | translate
      "
      (onPress)="goToFunctionParametersSettingClockWeekScreen()"
    >
    </app-larged-link>
  }

  <app-label-description
    [description]="'P0003601.filtration.reglage.descriptionHorloge' | translate"
  ></app-label-description>
}

@if (actionStack!.getValue('fvsCProgrammeFiltrationAuto') === 2) {
  <app-two-choices-control
    [title]="'P0003601.programme.horlogeEte' | translate"
    [firstLabel]="
      'P00039.lighting.functionality.parameters.setting.title.clock.day'
        | translate
    "
    [firstValue]="0"
    [secondLabel]="
      'P00039.lighting.functionality.parameters.setting.title.clock.week'
        | translate
    "
    [secondValue]="1"
    [value]="actionStack!.getValue('fvsPTypeHorlogePPE')"
    (onChange)="
      this.actionStack!.editValue(
        P00039DataRxTxIndex.FiltrationVS_Parametrage4,
        'fvsPTypeHorlogePPE',
        $event
      );
      this.actionStack!.commit()
    "
  >
  </app-two-choices-control>

  @if (this.actionStack!.getValue('fvsPTypeHorlogePPE') === 0) {
    <app-larged-link
      [name]="
        'P0003600.installation.filtration.programmePPH.horlogePicotsJoursPPH.programmeTitre'
          | translate
      "
      (onPress)="goToFunctionParametersSettingsClockPPEScreen()"
    >
    </app-larged-link>
  } @else {
    <app-larged-link
      [name]="
        'P0003600.installation.filtration.programmePPH.horlogePicotsJoursPPH.programmeTitre'
          | translate
      "
      (onPress)="goToFunctionParametersSettingClockWeekPPEScreen()"
    >
    </app-larged-link>
  }

  <app-label-description
    [description]="'P0003601.filtration.reglage.descriptionHorloge' | translate"
  ></app-label-description>
}

<app-switch-configuration
  [title]="
    'P0003601.installation.prevention.filtrationForceeEauChaude2424' | translate
  "
  [nameCustom]="
    'P0003601.installation.prevention.activationFonctionFiltration2424.smallTitle'
      | translate
  "
  [value]="actionStack!.getValue('fvsPActivationFonction2424') !== 0"
  (onPress)="
    this.actionStack!.editValue(
      P00039DataRxTxIndex.FiltrationVS_Parametrage4,
      'fvsPActivationFonction2424',
      $event ? 1 : 0
    );
    this.actionStack!.commit()
  "
>
</app-switch-configuration>

@if (actionStack!.getValue('fvsPActivationFonction2424') === 1) {
  <app-label-configuration
    [titleListe]="
      'P0003601.installation.prevention.seuilTemperatureFonctionFiltration2424.smallTitle'
        | translate
    "
    [value]="actionStack!.getValue('fvsPSeuilTemperature2424')"
    [liste]="P0003601SeuilTemperatureFiltration2424()"
    (onPress)="
      this.actionStack!.editValue(
        P00039DataRxTxIndex.FiltrationVS_Parametrage2,
        'fvsPSeuilTemperature2424',
        $event
      );
      this.actionStack!.commit()
    "
  >
  </app-label-configuration>
}

<app-label-description
  [description]="
    'P0003601.installation.prevention.activationFonctionFiltration2424.description.' +
      getTemperatureType() | translate
  "
></app-label-description>

<div class="my-2">
  <div class="row">
    <div class="col">
      <ion-label class="color-medium text-uppercase">{{
        'P0003600.installation.preventiongel.typeFonctionHorsGel.title'
          | translate
      }}</ion-label>
    </div>
  </div>
</div>

@if (hasProduitP00032() > 0 && hasProduitP00030() > 0) {
  <app-label-configuration
    [titleListe]="
      'P0003601.installation.prevention.capteurTemperatureReferenceHorsGel.smallTitle'
        | translate
    "
    [value]="actionStack!.getValue('fvsICapteurTemperatureReferenceHorsGel')"
    [liste]="P0003601CapteurTemperatureEnum"
    (onPress)="
      this.actionStack!.editValue(
        P00039DataRxTxIndex.FiltrationVS_Installation,
        'fvsICapteurTemperatureReferenceHorsGel',
        $event
      );
      this.actionStack!.commit()
    "
  >
  </app-label-configuration>
}

<app-label-configuration
  [titleListe]="
    'P0003601.installation.prevention.seuilTemperatureReferenceHorsGel.smallTitle'
      | translate
  "
  [value]="actionStack!.getValue('fvsPSeuilTemperatureHorsGel')"
  [liste]="P0003601SeuilTemperatureHorsGel()"
  (onPress)="
    this.actionStack!.editValue(
      P00039DataRxTxIndex.FiltrationVS_Parametrage4,
      'fvsPSeuilTemperatureHorsGel',
      $event
    );
    this.actionStack!.commit()
  "
>
</app-label-configuration>

<app-label-description
  [description]="
    'P0003601.installation.preventiongel.typeFonctionHorsGel.description'
      | translate
  "
></app-label-description>
